import { Navigate, Outlet, useLocation } from "react-router-dom";
import { canAccessView, routeForView, allowedViewsForUser } from "../auth/viewAccess";
import { routeAfterLogin } from "../auth/routeAfterLogin";
import { useAuth } from "../state/AuthProvider";

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "checking") {
    return (
      <div className="auth-loading-screen">
        <p className="muted">Checking session…</p>
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export function RequireManagement() {
  const { user, status } = useAuth();

  if (status !== "authenticated" || !user) return null;
  if (!canAccessView(user, "management")) {
    return <Navigate to={routeForView("staff")} replace />;
  }

  return <Outlet />;
}

export function RequireStaff() {
  const { user, status } = useAuth();

  if (status !== "authenticated" || !user) return null;
  if (!canAccessView(user, "staff")) {
    const views = allowedViewsForUser(user);
    return <Navigate to={routeForView(views[0] ?? "management")} replace />;
  }

  return <Outlet />;
}

export function LoginRoute() {
  const { status, user } = useAuth();

  if (status === "checking") {
    return (
      <div className="auth-loading-screen">
        <p className="muted">Checking session…</p>
      </div>
    );
  }

  if (status === "authenticated" && user) {
    return <Navigate to={routeAfterLogin(user, null)} replace />;
  }

  return <Outlet />;
}
